module.exports = "<svg viewBox=\"0 0 10 10\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M6.678 5.036L9.892 1.82 8.285.215 5.07 3.428 1.858.214.25 1.82l3.214 3.216L.25 8.25l1.607 1.607L5.07 6.643l3.215 3.214L9.892 8.25 6.678 5.036z\" class=\"closeIcon\" fill-rule=\"evenodd\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./~/svg-inline-loader!./client/components/ProgressBarPane/close.svg
// module id = 660
// module chunks = 0